import { HEADER_ACCOUNT_TOKEN } from "@faire/web--source/common/consts/HEADER_ACCOUNT_TOKEN";
import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { IBrand } from "@faire/web-api--source/indigofair/data/IBrand";
import { IRetailer } from "@faire/web-api--source/indigofair/data/IRetailer";

import { headerInterceptorFactory } from "./headerInterceptor";

export const tokenHeaderInterceptor = headerInterceptorFactory({
  header: HEADER_ACCOUNT_TOKEN,
  value: () => {
    const brandToken = getGlobalProperty<IBrand>("brand")?.token;
    const retailerToken = getGlobalProperty<IRetailer>("retailer")?.token;

    if ((brandToken && retailerToken) || (!brandToken && !retailerToken)) {
      return;
    }

    return brandToken ?? retailerToken;
  },
});
